import React, { Fragment } from 'react'
import styles from './ProfileButton.scss'
import cx from 'classnames'
import { PopoverLinkMenu, PopoverLinkMenuItem as MenuItem } from 'common/styleguide/PopoverLinkMenu'
import { Icon } from 'common/LegacyIcon'
import { Icon as NewIcon } from 'common/Icon'
import { getCurrentUser } from 'lib/utils'
import { showModal } from 'lib/modalUtils'
import { Msg, featureNames } from 'lib/localization'
import { CHANGE_LOCALE_MODAL } from 'common/modals/ChangeLocaleModal'
import { FormattedMessage as T } from 'react-intl'

const currentUserFromConfig = getCurrentUser()

export class ProfileButton extends React.PureComponent {
  static defaultProps = {
    currentUser: currentUserFromConfig
  }

  constructor (props) {
    super(props)
    this.state = {
      showMenu: false
    }
    this._button = React.createRef()
  }

  showMenu = () => {
    this.props.closeLocaleBump()
    this.setState({ showMenu: true })
  }

  closeMenu = () => {
    this.setState({ showMenu: false })
  }

  render (props) {
    const { currentUser, id: divId, currentLanguage, intl } = this.props
    const {
      id: userId,
      accountLevel,
      highlightedPhotoId,
      numUnreadMessages,
      hasSubscription
    } = currentUser

    let profileImage = highlightedPhotoId ? `/photos/milli/${highlightedPhotoId}.jpg` : '/images/default-profile.jpg'

    // handle case where user is logged into organization account
    let isClub = false
    let isDefaultImage = false
    if (window.rwgps && window.rwgps.config && window.rwgps.config.club) {
      isClub = true
      profileImage = window.rwgps.config.club.logo
      isDefaultImage = /default/.test(profileImage)
    }

    const { showMenu } = this.state
    const hasUnread = numUnreadMessages > 0

    // /images/default-profile.jpg
    return (
      <div id={divId} className={styles.ProfileButton}>
        <a ref={this._button} className={cx(styles.profileButtonLink, hasUnread && styles.hasUnread, isClub && styles.clubLogo, isDefaultImage && styles.defaultImage)} onClick={this.showMenu}>
          <img alt='Your profile photo' src={profileImage} />
          {!showMenu && <Icon i='downChevron' className={styles.chevron} size={20} />}
          {showMenu && <Icon i='upChevron' className={styles.chevron} size={20} />}
        </a>
        {showMenu &&
          <PopoverLinkMenu
            intl={intl}
            insideMargin={false}
            placement='bottom'
            target={this._button}
            containerPadding={15}
            onRequestClose={this.closeMenu}>
            <MenuItem href={`/users/${userId}/`}><Msg m={isClub ? featureNames.home : featureNames.profile} /></MenuItem>
            {!isClub && <MenuItem href={`/users/${userId}/conversations`} className={cx(hasUnread && styles.hasUnreadListItem)}><Msg m={featureNames.messages} /></MenuItem>}
            {!isClub && <MenuItem href='/settings/account'><Msg m={featureNames.settings} /></MenuItem>}
            {!isClub && hasSubscription && <MenuItem href='/subscriptions/manage'><T id='profileButtonLink.manageSub' defaultMessage='Manage Subscription' /></MenuItem>}
            {accountLevel < 1 && <MenuItem href='/choose_account'><Msg m={featureNames.upgrade} /></MenuItem>}
            <MenuItem href='/help'><Msg m={featureNames.help} /></MenuItem>
            <MenuItem href='/logout' id='logout-link'><T id='profileButton.signOut' defaultMessage='Sign Out' /></MenuItem>
            <Fragment>
              <li className={styles.hr} />
              <MenuItem onClick={() => { this.closeMenu(); showModal(CHANGE_LOCALE_MODAL) }}><NewIcon i='ios-globe-outline' size={15} /> {currentLanguage}</MenuItem>
            </Fragment>
          </PopoverLinkMenu>}
      </div>
    )
  }
}
